<template>
    <svg width="48" height="23" viewBox="0 0 48 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M46.668 12.1L40.0982 20.2C39.206 21.3 38.0705 21.9 36.8539 21.9H2.62602C1.97715 21.9 1.65272 20.9 2.05826 20.3L8.70917 12.1C9.60136 11 10.7369 10.4 11.9535 10.4L46.1002 10.5C46.8302 10.5 47.1546 11.5 46.668 12.1Z"
              fill="currentColor" stroke="currentColor" stroke-width="2" stroke-miterlimit="5"/>
        <path d="M46.668 2.7L40.0982 10.8C39.206 11.9 38.0705 12.5 36.8539 12.5H2.62602C1.97715 12.5 1.65272 11.5 2.05826 10.9L8.70917 2.7C9.60136 1.6 10.7369 1 11.9535 1L46.1002 1.1C46.8302 1.1 47.1546 2.1 46.668 2.7Z"
              fill="white" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
    </svg>
</template>

<script>
    export default {
        name: "SVGShadeOn"
    }
</script>

<style scoped>

</style>
